"use client";

import { CiLogout } from "react-icons/ci";
import Image from "next/image";
import Link from "next/link";

import { hardSignOut } from "@/lib/auth/clientSignOut";
import { TRAINING_MODE_NAV } from "@/lib/navigation/nav-manifest";
import logoOrange from "../../public/logo-orange.png";

/**
 * The minimal header restricted training-mode users get: no dropdowns, no
 * studio switcher, and only the four destinations they can reach. The links
 * come from the manifest so ⌘K indexes exactly this set for them.
 */
export default function TrainingModeNav({
  session,
  normalizedPathname,
  displayLogo,
  displayName,
}) {
  return (
    <nav className="sticky top-0 z-50 bg-surface-chrome border-b border-stone-200/70">
      <div className="container flex items-center justify-between w-full px-4 py-3 mx-auto md:px-6">
        <div className="flex items-center gap-6">
          <Link href="/training" className="flex items-center">
            {session?.workspace?.image ? (
              <Image
                src={session.workspace.image}
                alt={`${session?.workspace?.name || "Studio"} Logo`}
                width={200}
                height={200}
                className="object-contain w-auto h-8"
                priority
              />
            ) : (
              <Image
                src={displayLogo || logoOrange}
                alt={`${displayName || "Salesably"} Logo`}
                width={130}
                height={40}
                className="object-contain w-auto h-8"
                priority
              />
            )}
          </Link>
          <div className="flex items-center gap-4">
            {TRAINING_MODE_NAV.items.map((item) => {
              const isActive =
                normalizedPathname === item.href ||
                normalizedPathname.startsWith(`${item.href}/`);

              return (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`text-sm font-medium transition-colors ${
                    isActive
                      ? "text-orange-700"
                      : "text-gray-600 hover:text-gray-900"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <span className="hidden sm:inline text-sm text-gray-600">
            {session?.user?.name || session?.user?.email}
          </span>
          <button
            onClick={() => hardSignOut("/")}
            className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            <CiLogout className="w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
